<i18n>
{
  "fr": {
    "field-optional": "Facultatif"
  }, 
  "en": {
    "field-optional": "Optional"
  }
}
</i18n>

<template>
  <b-field v-bind="bFieldProps">
    <slot></slot>
  </b-field>
</template>

<script>
import Field from 'buefy/src/components/field/Field.vue'
import { Rules } from '@/mixins/form/rules'

export default {
  name: 'SField',
  mixins: [Field, Rules],
  props: {
    optional: {
      type: Boolean,
      required: false,
      default: false
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    bFieldProps() {
      let props = {}

      Object.keys(Field.props).forEach((prop) => {
        if (this.$props[prop]) {
          props[prop] = this.$props[prop]
        }
      })

      props.customClass = `${props.customClass} {${this.customClass}}`
      props.message = typeof props.message === 'string' ? [props.message] : props.message || []

      if (this.optional) {
        props.message.push(this.$t('field-optional'))
      }

      if (this.error) {
        props.type = 'is-danger'
        props.message.push(this.error)
      }

      if (props.message.length <= 0) {
        props.message = null
      }

      return props
    }
  }
}
</script>
